import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  iconName: IconProp;
  title: string;
  description: string;
  classes?: string;
  inverted?: boolean;
}

export const InfoCard = (props: Props): JSX.Element => {
  const { inverted, title, description, classes, iconName } = props;
  const invertedTitleClasses = '!text-white';

  return (
    <div className={`px-4 place-content-center rounded-lg border-[1px] border-solid border-gray-300 group 
      mb-5 mx-5 ${inverted ? invertedTitleClasses : ' '} ${classes ?? ''}`}>
      <div className='block mb-3 mt-4 flex flex-row'>
        <div className='rounded-full bg-emerald-300 flex justify-center p-2 mr-2'>
          <FontAwesomeIcon icon={iconName} className='text-emerald-700 text-2xl' />
        </div>
        <span className='mt-1 font-bold text-base self-center'>{title}</span>
      </div>
      <div className='block text-sm mb-3 text-left'>
        {description}
      </div>
    </div>
  );
};
